import {EventTag} from '@/apiTypes/eventTag';
import {Pill} from '@/components/ui/pill';
import {Typography} from '@/components/ui/typography';

interface EventTagsProps {
  tags: EventTag[];
}

/**
 * Renders an event's public tags as a row of chips. Returns null when
 * the tag list is empty so callers can drop it in without an empty-state
 * branch. Pure atom — no fetching, no conditional placement logic.
 */
export function EventTags({tags}: EventTagsProps) {
  if (tags.length === 0) return null;
  return (
    <div className="space-y-2">
      <Typography level="LABEL">Tags</Typography>
      <div className="flex flex-wrap gap-1.5">
        {tags.map((t) => (
          <Pill key={t.id} size="sm" variant="ghost">
            {t.name}
          </Pill>
        ))}
      </div>
    </div>
  );
}
